module.exports = [
	{
		"name": "charge",
		"colors": {
			"A": "#DDDDDD",
			"R": "#145AFF",
			"N": "#FF7C70",
			"D": "#E60A0A",
			"C": "#CCCCCC",
			"Q": "#FF4C4C",
			"E": "#E60A0A",
			"G": "#DDDDDD",
			"H": "#7070FF",
			"I": "#CCCCCC",
			"L": "#CCCCCC",
			"K": "#145AFF",
			"M": "#CCCCCC",
			"F": "#CCCCCC",
			"P": "#CCCCCC",
			"S": "#DDDDDD",
			"T": "#DDDDDD",
			"W": "#CCCCCC",
			"Y": "#CCCCCC",
			"V": "#CCCCCC",
			"ALA": "#DDDDDD",
			"CYS": "#145AFF",
			"ASP": "#FF7C70",
			"GLU": "#DDDDDD",
			"PHE": "#CCCCCC",
			"GLY": "#FF4C4C",
			"HIS": "#E60A0A",
			"ILE": "#FF7042",
			"LYS": "#7070FF",
			"LEU": "#CCCCCC",
			"MET": "#CCCCCC",
			"ASN": "#145AFF",
			"PRO": "#CCCCCC",
			"GLN": "#CCCCCC",
			"ARG": "#CCCCCC",
			"SER": "#DDDDDD",
			"THR": "#DDDDDD",
			"VAL": "#CCCCCC",
			"TRP": "#CCCCCC",
			"TYR": "#CCCCCC"
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/colors.json
// module id = 34
// module chunks = 0